import React from 'react';
import Cookies from 'universal-cookie';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';

const cookies = new Cookies();

class Login extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:"",
            last_name:"",
            email:"",
            phone_number:"",
            password:"",
            password_confirmation:"",
            address:"",
            pais:"",
            distrito:"",
            doc_number:"",
            loading:false,
            message_serve:"",
            message_serve_e:"",
            perfil:"",
            loading1:true,
            bim_user:[],
            message_Bim:"",
           
        }
    }
    handleChange=async e=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }

    readImage=(e)=>{
        var file = e.target.files[0];
        if (!file)
       return;

        var reader = new FileReader();
        reader.onload = fileOnload;
        reader.readAsDataURL(file);
        this.setState({
            perfil:e.target.files[0],
        });
      function fileOnload(e) {
        var result=e.target.result;
        document.querySelector('#showImage').src=result ;

       }

       

    console.log(cookies.get("url_photo"));
        
    }

    componentDidMount() {
        if(cookies.get('id')){
          
        }else{
            window.location.href="/";
        }

        this.getBimUser();
        window.scrollTo(0, 0);

    }

    getBimUser = () =>{
        this.setState({loading1: true});

        API.PRODUCTS.post('bim/user/download',{
            user_id:cookies.get("id"),
        })
        .then(resp =>{
            this.setState({
                loading1: false,
                bim_user:resp.data.bim_user,
            });
            console.log(resp.data);
            
        })
        .catch(err =>{
            this.setState({
                loading1: false,
                message_Bim:"ERROR AL CARGAR",
            });
            console.log(err);
        });
    }
  
    
    handleSubmit=(e)=>{
        this.setState({message_serve_e:"",loading:true});
        const formData = new FormData();
        e.preventDefault();
        formData.append('perfil',this.state.perfil);
        formData.append('id',cookies.get("id"));
        formData.append('name',this.state.name);
        formData.append('last_name',this.state.last_name);
        formData.append('email',this.state.email);
        formData.append('address',this.state.address);
        formData.append('phone_number',this.state.phone_number);
        formData.append('password',this.state.password);
        formData.append('password_confirmation',this.state.password_confirmation);
        formData.append('pais',this.state.pais);
        formData.append('distrito',this.state.distrito);
        formData.append('doc_number',this.state.doc_number);
        /*id:cookies.get("id"),
        name:this.state.name,
        last_name:this.state.last_name,
        email:this.state.email,
        phone_number:this.state.phone_number,
        password:this.state.password,
        password_confirmation:this.state.password_confirmation,
        phone_number:this.state.phone_number,
        email:this.state.email,
        address:this.state.address,
        pais:this.state.pais,
        distrito:this.state.distrito,
        doc_number:this.state.doc_number,*/

        
        API.PRODUCTS.post('register_edit',formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response=>{
            this.setState({
                loading:false
            })
            console.log(response);
            if(response.data.message=="error"){
               // alert('El usuario o la contraseña no son correctos');
                this.setState({
                    message_serve_e:"Rellene bien los datos",
                    loading:false
                })
            }else{
                
            return response;
            }
        })
        .then(response=>{
            //console.log(response);
            if(response.status==200){
                
                var respuesta=response.data;
                cookies.set('id', respuesta.id, {path: "/"});
                cookies.set('name', respuesta.name, {path: "/"});
                cookies.set('last_name', respuesta.last_name, {path: "/"});
                cookies.set('email', respuesta.email, {path: "/"});
                cookies.set('pais', respuesta.pais, {path: "/"});
                cookies.set('address', respuesta.address, {path: "/"});
                cookies.set('distrito', respuesta.distrito, {path: "/"});
                cookies.set('doc_number', respuesta.doc_number, {path: "/"});
                cookies.set('phone_number', respuesta.phone_number, {path: "/"});
                cookies.set('url_photo', respuesta.url_foto, {path: "/"});

                
               /* this.setState({
                    name:respuesta.name,
                    last_name:respuesta.last_name,
                    email:respuesta.email,
                    phone_number:respuesta.phone_number,
                    address:respuesta.address,
                    pais:respuesta.pais,
                    distrito:respuesta.distrito,
                    doc_number:respuesta.doc_number,
                    loading:false,
                    perfil:respuesta.url_foto
                });*/

            window.location.href="perfil";
                
            }else{
                this.setState({loading:false,message_serve_e:"asegúrese de llenar bien los datos"});
            }
        })
        .catch(err => {
            console.log(err);
            this.setState({loading:false,message_serve_e:"asegúrese de llenar bien los datos"});
                //console.log(err.error);
            
        })
    }

    
    

    render(){
        return(
            
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <div className="col-md-10 col-sm-12 mx-auto row"> 
                        <div className="col-md-2 col-sm-12">
                        
                        
                        <   div className="photo-perfil">
                                {/*<label >Portada</label>*/}
                                <label id="file-upload" htmlFor="file_upload" className="upload-content">
                                <div className="file-image">
                                <span id="text-info"><i className="fa fa-upload"></i> Sube tu foto <i className="fas fa-user-cog"></i></span>
                                
                                {cookies.get('url_photo')!="null" ?
                                            <img id="showImage" src={cookies.get("url_photo")} width="100%"></img>
                                            :
                                            <img id="showImage"  src="/assets/profile-default.png" width="100%"></img>
                                    }
                                </div>
                                </label>
                                </div> 

                        <ul className="nav nav-tabs ul-menu" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Datos Personales</a>
                            </li>
                           <li className="nav-item" role="presentation">
                                <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">BIM/CAD Descargados</a>
                            </li>
                            {/*<li className="nav-item" role="presentation">
                                <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Contact</a>
                            >*/}
                            </ul>
                        </div>

                        <div className="col-md-10 col-sm-12 border-solid">
                            
                            <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active datos-div" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <p className="editar-text">Editar Perfil</p>   
                                <hr></hr>
                                <h1>{cookies.get("name")} {cookies.get("last_name")}</h1>
                                <p className="text-datos">Datos Personales</p>
                                <div className="d-flex justify-content-center">
                                {this.state.loading==true
                                    ?
                                        <BarLoader
                                            width={100}
                                            height={4}
                                            color={APP_CONFIG.spinner_color}
                                            loading={this.state.loading}
                                        />

                                    :""}
                                        {this.state.message_serve_e!==''&&
                                        <div className="error">{this.state.message_serve_e}</div>
                                        }
                                        
                                </div>
                                <form id="login" onSubmit={this.handleSubmit} className="form-perfil row">
                                <input id="file_upload" type="file" name="perfil" accept="image/*" style={{display:"none"}}onChange={this.readImage} ref="input"></input>
                        
                                    <section className="col-xs-12 col-md-4">
                                        <label>Nombre</label>
                                            <div className="form-group">                  
                                            <input type="text" onChange={this.handleChange} className="form-control" id="name" name="name" placeholder="Nombre" required defaultValue={cookies.get("name")} />                 
                                            </div>                
                                        </section>
                                        <section className="col-xs-12 col-md-4">
                                        <label>Apellidos</label>
                                            <div className="form-group">                  
                                            <input type="text" onChange={this.handleChange} className="form-control" id="last_name" name="last_name" placeholder="Apellidos" required defaultValue={cookies.get("last_name")}/>                 
                                            </div>                
                                        </section>
                                        <section className="col-xs-12 col-md-4">
                                            <label>Teléfono</label>
                                            <div className="form-group">                  
                                            <input type="number" onChange={this.handleChange} className="form-control" id="phone_number" name="phone_number" placeholder="Teléfono" required defaultValue={cookies.get("phone_number")}/>                 
                                            </div>                
                                        </section>
                                        
                                        <section className="col-xs-12 col-md-4">
                                            <label>Email</label>
                                            <div className="form-group">                  
                                            <input type="email" onChange={this.handleChange} className="form-control" id="email" name="email" placeholder="Email" required defaultValue={cookies.get("email")}/>                 
                                            </div>                
                                        </section>
                                    
                                        

                                        <section className="col-xs-12 col-md-4">
                                            <label>Dirección</label>
                                            <div className="form-group">                  
                                            <input type="text" onChange={this.handleChange} className="form-control" name="address" id="address" placeholder="Dirección" defaultValue={cookies.get("address")}/>
                                            </div>                
                                        </section>

                                        <section className="col-xs-12 col-md-4">
                                            <label>Pais</label>
                                            <div className="form-group">                  
                                            <input type="text" onChange={this.handleChange} className="form-control" name="pais" id="pais" placeholder="Pais" defaultValue={cookies.get("pais")}/>
                                            </div>                
                                        </section>

                                        <section className="col-xs-12 col-md-4">
                                            <label>Distrito</label>
                                            <div className="form-group">                  
                                            <input type="text" onChange={this.handleChange} className="form-control" name="distrito" id="distrito" placeholder="Distrito" defaultValue={cookies.get("distrito")}/>
                                            </div>                
                                        </section>
                                        <section className="col-xs-12 col-md-4">
                                            <label>Nro Documento</label>
                                            <div className="form-group">                  
                                            <input type="number" onChange={this.handleChange} className="form-control" name="doc_number" id="doc_number" placeholder="Nro Documento" defaultValue={cookies.get("doc_number")}/>
                                            </div>                
                                        </section>

                                        <section className="col-xs-12 col-md-4">
                                            <label>Contraseña</label>
                                            <div className="form-group">                  
                                            <input type="password" onChange={this.handleChange} className="form-control" name="password" id="password" placeholder="Contraseña" />
                                            </div>                
                                        </section>

                                        <section className="col-xs-12 col-md-4">
                                            <label>Confirmar Contraseña</label>
                                            <div className="form-group">                  
                                            <input type="password" onChange={this.handleChange} className="form-control" name="password_confirmation" id="password_confirmation" placeholder="Confirmar contraseña" />
                                            </div>                
                                        </section>
                                        <section className="col-xs-12 col-md-4">
                                            <label></label>
                                            <div className="form-group">                  
                                            <button type="submit" className="cerrar-a btn-actualizar" >Actualizar</button>
                                        </div>                
                                        </section>
                                        
                                    
                                        
                                    </form>
                            </div>
                            
                            <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <p className="editar-text">BIM/CAD DESCARGADOS</p>   
                                <hr></hr>
                                <br></br>
                                <div className="d-flex justify-content-center">
                                    {this.state.loading1==true?
                                        <BarLoader
                                        width={100}
                                        height={4}
                                        color={APP_CONFIG.spinner_color}
                                        loading1={this.state.loading1}
                                        />
                                        
                                    :
                                     ""
                                    }        
                                        
                                </div>
                                {this.state.bim_user.length>0
                                ?
                                <div className="row row-cols-1 row-cols-md-5" >
                                    {this.state.bim_user.map((bim_d,index) =>(

                                    <div className="col mb-4 mb-4-white">
                                        <a href={"/producto/"+bim_d.bim.producto.slug+"#div_bim"}>
                                            <div className="card" key={index}>
                                            
                                            {bim_d.bim.producto.product_images.map((img,index) =>(
                                                <div key={index}> 
                                                    {img.is_main==1
                                                    ?
                                                    <div className="img"><img src={img.thumbnail} className="card-img-top" alt="..."></img></div>  
                                                    :
                                                    ""
                                                    }
                                                </div>
                                               
                                               
                                               
                                        
                                            ))}
                                            
                                            <div className="card-body">
                                                <p className="text-center"><img  className="img-format" src={bim_d.bim.formato.url_icon}></img></p>
                                                <h5 className="card-title text-center">{bim_d.bim.formato.name}</h5>
                                                <p className="card-text text-center">[ {bim_d.bim.peso} ]</p>
                                                <p className="fecha text-center"> {bim_d.created_at}</p>   
                                                <p className="card-text text-center"> {bim_d.bim.name}</p>
                                                <p className="card-text text-center">{bim_d.count}&nbsp;  <i className="fas fa-download"> </i></p>
                                            </div>
                                            </div>
                                        </a>
                                        
                                    </div>
                                     ))}
                                 </div>
                                :
                                <div>

                                <br></br>
                                {this.state.message_Bim==""
                                ?
                                <p className="text-center">Aún no tiene BIM/CAD descargados <a href="/BIM">Descargar aquí</a></p>
                                :
                                <p className="text-center" style={{color:'red',fontWeight:"700"}}>{this.state.message_Bim} . . .</p>
                                }
                               

                                </div>
                                }

                                <br></br><br></br>
                            </div>
                            
                            {/*<div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">c</div>*/}
                            </div>
                        </div>
                       
                    </div> 
                   
                </div>
            </div>
           
        );
    
}

}
export default Login;